<template lang="pug">
.tweet-section(v-if="tweets && tweets.length", @drop.prevent="drop")
  .headers
    .header.selected Tweets
  .items.vertical
    .tweet(v-for="(tweet, index) in tweets",
           :key="tweet",
           :class="{ 'drop-target': editable && index === dropBefore, editing }",
           :id="`t|${ tweet }`",
           :draggable="editing",
           @dragstart="start",
           @dragover.prevent="tweetOver(tweet)")
      //.id {{ tweet }}
      .wrap(v-if="true || show(tweet, index)")
        .mask
        .delete(@click.stop="deleteTweet(tweet)", title="Remove tweet")
        .embed
          tweet(:id="tweet", :options="{ cards: 'hidden', conversation: 'none' }")
    //-.tweet.load-more(v-if="maxTweets < tweetsLength()", @click="maxTweets = maxTweets + (expandTweets && 10 || 30)")
      .button load more
</template>
<script>
import { Tweet } from 'vue-tweet-embed';
import { mapActions } from 'vuex';
import { vuexComputed, moveOrAdd } from '@/helpers';
export default {
  name: 'tweets',
  props: {
    tweets: Array,
    editable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...vuexComputed(
      'lazyLevel',
      'sharing',
      'dragType',
      'dropBefore',
      'loadedTweets'
    ),
    editing() {
      const { editable, $store: { getters } } = this;
      return editable && getters.editing;
    }
  },
  methods: {
    ...mapActions(['deleteTweet']),
    date(pa) {
      return new Date(pa);
    },
    playVidById(id) {
      const [vid] = this.playlist?.filter(vid => vid.id === id) || [];
      console.log('playVidById', vid);
      if (vid) {
        this.currentVideo = vid;
      }
    },
    start({ dataTransfer, target: { id }, target, preventDefault }) {
      const stripper = /^([dvpit])\|/;
      const chararcter = (stripper.exec(id) || [])[1];
      console.log('chararcter', chararcter);
      const { playlist } = this;
      const actions = {
        v() {
          const [vid] = playlist?.filter(vid => vid.id === id.replace(stripper, '')) || [];
          if (vid) {
            dataTransfer.setData('text/plain', 'v|' + JSON.stringify(vid));
            //this.editingReadingList = false;
            //this.dragType = 'video';
          } else {
            // this is throwing
            //preventDefault();
          }
        }
      };
      actions.d = actions.i = actions.t = actions.p = setId;
      (actions[chararcter] || actions.v)();
      function setId() {
        dataTransfer.setData('text/plain', id);
      }
    },
    tweetOver(id) {
      const { tweets } = this;
      const index = tweets.indexOf(id);
      this.dropBefore = index;
      this.dragType = 'tweet';
    },
    drop(e) {
      const { dropBefore: to, playlist, dragType } = this;
      const { dataTransfer } = e;
      const data = dataTransfer.getData('text/plain');
      const stripper = /^([dvpit])\|/;
      const stripped = (data || '').replace(stripper, '');
      const character = (stripper.exec(data) || [])[1];
      const kind = ({ d: 'document', v: 'video', p: 'page', i: 'insight', t: 'tweet' })[character];
      console.log('drop kind', character, kind, dragType, data, stripped);
      if (kind === 'tweet' && dragType === 'tweet') {
        const id = stripped;
        const { dropBefore: to, loadedTweets } = this;
        moveOrAdd(loadedTweets, to, id);// && (this.loadedDocuments = loadedDocuments);
      } else {
        console.log('wrong drag type, was', dragType || 'null', 'expected video, document, or page');
      }
      this.dropBefore = null;
    }
  },
  components: { tweet: Tweet }
};
</script>
<style scoped lang="scss">
@import '../../scss/global';
.tweet-section {
  padding: 1rem;
  .headers {
    background-color: white;
  }
  .items {
    padding-top: 1rem;
    padding-bottom: 1rem;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    display: flex;
    flex-flow: column wrap;
    &.vertical {
      flex-flow: row wrap;
      justify-content: space-around;
      & > .tweet {
        width: 31rem;
        &.load-more {
          width: 100%;
          padding-top: 15%;
        }
      }
    }
    height: 100%;
    @include large {
      height: 63%;
      &.no-results {
        height: 80%;
        justify-content: center;
        .message {
          align-self: center;
          font-size: 3rem;
          color: #ccc;
          margin-top: -10rem;
          text-transform: capitalize;
        }
      }
    }
    & > .tweet {
      width: 30%;
      will-change: transform;
      transition: transform 250ms ease-in-out;
      @include portrait {
        @include small {
          width: 70vw;
        }
      }
      &.drop-target {
        transform: translate3d(1.5rem, 0, 0);
        &::before {
          content: '\00a0';
          position: absolute;
          top: 0;
          left: -1rem;
          height: 100%;
          width: 0.25rem;
          background-color: $brn;
        }
      }
      &.editing {
        .wrap {
          .mask {
            opacity: 1;
            pointer-events: all;
          }
        }
      }
      .wrap {
        position: relative;
        .mask {
          opacity: 0;
          pointer-events: none;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          z-index: 1003;
        }
      }
      &.load-more {
        padding-top: 25%;
        position: relative;
        .button {
          padding: 1rem 2rem;
          color: #777;
          cursor: pointer;
          border: 2px solid #777;
          border-radius: 4px;
          position: absolute;
          white-space: nowrap;
          top: 50%;
          left: 50%;
          transform: translate3d(-50%, -50%, 0);
        }
      }
      & > .id {
        display: none;
      }
    }
  }
}
</style>
